import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import CustomFooter from '../../login/CustomFooter'
import { Layout, Row, Col } from 'antd'
import { isReadOnlyTeacherId } from '../../Util'
const Content = Layout.Content

class TeacherRecords extends Component {
    state = {

    }

    componentDidMount() {
        document.title = 'Records - Dot It'
    }

    render() {
        return (
            <div>
                <Layout className="content layout-header-mt">
                    <Layout>
                        <Content className="layout-content">
                            <div className="sub-menu-width m-lr-auto">
                                <div className='br-20 overflow-hidden mb-3'>
                                    <div className='br-4 relative pl-3 pr-3 pt-3 relative'
                                        style={{ height: '220px', }}>

                                        <div className="absolute-tl w-100 h-100" style={{ backgroundColor: '#233142' }}>
                                        </div>
                                        <div className="absolute-tl w-100 h-100"
                                        >
                                        </div>
                                        <div className='absolute-tl w-100 h-100'>
                                            <div className='h-100'>
                                                <div className='flex flex-v-center font-40 font-fff w-100 h-100 p-4'>
                                                    <div className='w-100'>
                                                        <div className='font-40 font-bold font-fff'>Records</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.props.teacherBaseProps && this.props.teacherBaseProps.teacher ?
                                    <Row gutter={32}>
                                        <Col span={24}>

                                            <Link to={'/teacher/reports/' + this.props.teacherBaseProps.teacher.id}>
                                                <div className={"p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 font-black"}>
                                                    <div className="br-4 overflow-hidden">
                                                        <img src="/record-icon1.png" alt="records icon" height="100" />
                                                    </div>
                                                    <h2 className="ml-3 font-24 font-bold">
                                                        View reports
                                                    </h2>
                                                </div>
                                            </Link>
                                        </Col>
                                        {/*<Col span={12}>
                                            <Link
                                                to={'/teacher/archived/students/' + this.props.teacherBaseProps.teacher.id}
                                                disabled={isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)}
                                            >
                                                <div
                                                    className={isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id) ?
                                                        "p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 disabled-text cursor-not-allowed" :
                                                        "p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 font-black"}
                                                >
                                                    <div className="br-4 overflow-hidden">
                                                        <img src="/record-icon2.png" alt="records icon" height="100" />
                                                    </div>
                                                    <h2 className="ml-3 font-24 font-bold">
                                                        View archived students
                                                    </h2>
                                                </div>
                                            </Link>
                                        </Col>
                                        <Col span={12}>
                                            <Link
                                                to={'/teacher/transfers/students/' + this.props.teacherBaseProps.teacher.id}
                                                disabled={isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)}
                                            >
                                                <div
                                                    className={isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id) ?
                                                        "p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 disabled-text cursor-not-allowed" :
                                                        "p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 font-black"}
                                                >
                                                    <div className="br-4 overflow-hidden">
                                                        <img src="/record-icon3.png" alt="records icon" height="100" />
                                                    </div>
                                                    <h2 className="ml-3 font-24 font-bold">
                                                        Manage transferred students
                                                    </h2>
                                                </div>
                                            </Link>
                                        </Col>
                                        <Col span={12}>
                                            <Link
                                                to={'/teacher/deleted/students/' + this.props.teacherBaseProps.teacher.id}
                                                disabled={isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)}
                                            >
                                                <div
                                                    className={isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id) ?
                                                        "p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 disabled-text cursor-not-allowed" :
                                                        "p-2 br-20 border background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 font-black"}
                                                >
                                                    <div className="br-4 overflow-hidden">
                                                        <img src="/record-icon4.png" alt="records icon" height="100" />
                                                    </div>
                                                    <h2 className="ml-3 font-24 font-bold">
                                                        Recover deleted students
                                                    </h2>
                                                </div>
                                            </Link>
                                        </Col>*/}
                                    </Row>
                                    : ''}
                            </div>
                        </Content>
                    </Layout>
                </Layout>
                <CustomFooter />
            </div>
        )
    }
}

export default TeacherRecords
